// Форматирование значений дашбордов отчётов модуля reports: рубли (целые),
// проценты, числа, ru-RU. Общий кирпич для всех кубов (этап 5 редизайна).

import moment from 'moment';
import 'moment-timezone';

const rublesFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 0,
});

const countFormatter = new Intl.NumberFormat('ru-RU');

const percentFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'percent',
  maximumFractionDigits: 1,
});

// Компактные рубли для тиков оси графика: «1,2 млн ₽» вместо «1 234 567 ₽».
const rublesCompactFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  notation: 'compact',
  maximumFractionDigits: 1,
});

export const formatCount = (value: number): string => countFormatter.format(value);

// Целые минуты длительности (тепловая карта продолжительности записи):
// «45 мин». null → «—»: записей с датами нет, средней длительности тоже.
export const formatMinutes = (value: number | null): string => (
  value === null ? '—' : `${ countFormatter.format(Math.round(value)) } мин`
);

export const formatRublesCompact = (value: number): string => rublesCompactFormatter.format(value);

// null → «—»: у метрики был нулевой делитель (средний чек без оплат, явка без визитов),
// показывать 0 ₽ / 0 % вводило бы в заблуждение.
export const formatRubles = (value: number | null): string => (
  value === null ? '—' : rublesFormatter.format(value)
);

export const formatPercent = (value: number | null): string => (
  value === null ? '—' : percentFormatter.format(value)
);

const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';
const DATE_FORMAT = 'DD.MM.YYYY';

// Календарная дата "YYYY-MM-DD" → "DD.MM.YYYY": это уже дата, не мгновение
// (контракт беков), конвертация пояса не нужна. null → «—». Формат срезом —
// formatter зовётся на каждую строку таблиц и маркеров; непаддедное значение —
// fallback на moment. Поднято из tireStorage/columns.ts при втором потребителе —
// отчёте «Аналитика клиентов» (2026-09-25).
export const formatCalendarDate = (value: string | null): string => {
  if (value == null) { return '—'; }
  if (value.length !== 10) { return moment(value).format(DATE_FORMAT); }
  return `${ value.slice(8, 10) }.${ value.slice(5, 7) }.${ value.slice(0, 4) }`;
};

// Дата UTC в поясе отчёта (поле «Часовой пояс» фильтра): createdDate/
// implementedDate приходят UTC, «день создания» без приведения попадает не в
// ту корзину. null → «—»: нет значения, не ноль. Поднято из
// tireServiceOrders/columns.ts при втором потребителе — отчёте «Аналитика
// хранения» (2026-09-18).
export const formatUtcDateInZone = (value: string | null, timeZone: string): string => (
  value ? moment.tz(value, timeZone).format(DATE_TIME_FORMAT) : '—'
);

// Массив ФИО исполнителей → строка ячейки таблицы: массив в ячейку и текстовый
// фильтр DevExpress не годится. undefined/null прикрывает ответ старого бека
// без поля. Поднято из tireServiceOrders/columns.ts при втором потребителе.
export const joinExecutorNames = (names: string[] | null | undefined): string =>
  (names ?? []).join(', ');
